module.exports = __webpack_public_path__ + "static/img/bg03.5d9bd19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg03.png
// module id = rv31
// module chunks = 2